var valueScaleCorrection = {};
/**
 * @internal
 */
function addScaleCorrection(correctors) {
  for (var key in correctors) {
    valueScaleCorrection[key] = correctors[key];
  }
}
export { addScaleCorrection, valueScaleCorrection };